<template>
  <section id="main-wrap" class="pure-g">
    <div id="main-col" class="pure-u-3-5">

      <h3>{{grapevineName}}</h3>

      <div id="home-grapes" v-if="!noGrapes">
        <Grape v-for="grape in grapes" :grapeInstance="grape" :key="grape.id" />
      </div>

      <div id="no-grapes" v-if="noGrapes">
        <p>This grapevine doesn’t have any grapes yet.</p>
      </div>

    </div>
  </section>

</template>

<script>
  import Grape from './Grape.vue'
  import db from './firebaseInit'

  export default {
    name: 'grapevine',
    props: ['grapeID'],
    data () {
      return {
        grapevineName: '',
        grapeIDs: [],
        grapes: [],
        username: '',
        loading: true,
        search: '',
        noGrapes: false,
        grapesDatabase: this.$globals.grapesDatabase,
        grapevinesDatabase: this.$globals.grapevinesDatabase,
        isPress: this.$globals.isPress
      }
    },
    created () {
      this.fetchData()
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        this.getGrapevineGrapes()
        if (this.$route.params.name !== '') {
          this.grapevineName = decodeURIComponent(this.$route.params.name)
        }
      },
      getGrapevineGrapes: function () {
        console.log('getGrapevineGrapes')
        let vm = this
        vm.grapeIDs = []
        vm.grapes = []
        var grapevineRef = db.collection(vm.grapevinesDatabase).doc(vm.$route.params.id)
        grapevineRef.get().then(function (doc) {
          if (doc.exists) {
            vm.grapevineName = doc.data().name
            let grapes = doc.data().grapes
            for (var i = 0; i < grapes.length; i++) {
              vm.grapeIDs.push(grapes[i])
            }
            if (doc.data().groupvine) {
              let participants = doc.data().participants
              for (var participant in participants) {
                var obj = participants[participant]
                for (var g = 0; g < obj.grapes.length; g++) {
                  vm.grapeIDs.push(obj.grapes[g])                  
                }
              }
            }
            if (vm.grapeIDs.length == 0) {
              vm.noGrapes = true
            } else {
              vm.noGrapes = false
              vm.getGrapes()
            }
          }
        })
      },
      getGrapes: function () {
        console.log('get grapes')
        let vm = this
        var i = 0
        this.grapeIDs.forEach(grapeID => {
          db.collection(this.grapesDatabase).where('id', '==', grapeID).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              // console.log('fetch: ' + doc.id, ' => ', doc.data())
              var grapeData = doc.data()
              grapeData.docID = doc.id
              this.grapes.push(grapeData)
            })
          })
          i++
          if (i == this.grapeIDs.length) {
            setTimeout(function() {
              if (vm.grapeID && $('#grape-' + vm.grapeID).length > 0) {
                console.log('here: ' + vm.grapeID)
                $('html, body').animate({ scrollTop: $('#grape-' + vm.grapeID).offset().top }, 'slow')
              }
            }, 2000)
          }
        })
      }
    },
    components: {
      Grape
    }
  };
</script>

<style scoped>
  #main-wrap {
    background: #f9f9f9;
    min-height: 100vh;
  }
  #add-grape-button {
    width: 100%;
    margin: 0 auto 20px;
    background: #36a731;
    color: #fff;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 15px 20px;
  }
  #search-grapes {
    width: 60%;
    margin: 0 auto 20px;
    line-height: 30px;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
  }
  #home-grapes {
    margin-top: 40px;
  }
  .aux-col {
    box-sizing: border-box;
    padding: 30px 50px;
    text-align: left;
  }
  .aux-col > h5 {
    text-transform: uppercase;
    border-bottom: 1px solid #36a731;
    margin: 0 0 20px;
    padding-bottom: 8px;
    display: inline-block;
  }
  #no-grapes {
    padding-top: 60px;
    border-top: 1px solid #ccc;
  }
  #no-grapes p {
    font-size: 1.2em;
  }
</style>


// WEBPACK FOOTER //
// src/components/Grapevine.vue